// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content042_wrapper__G48X4","title":"Content042_title__ejSuG","items":"Content042_items___t_hn","content":"Content042_content__0zbXo"};